import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3121SubProject } from "../../U3121Service";

interface U3121SubProjectDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn;
  t: TFunction;
  NS: string;
}

function U3121SubProjectDeleteDlg({ handleDelete, t, NS }: U3121SubProjectDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={handleDelete.isDialogDeleteOpen}
      onClose={handleDelete.handleDeleteCloseDlg}
      title={t("lblDeleteDlgTitle", { ns: NS })}
    >
      <p className="mb-4">{t("msgDeleteSubProject", { ns: NS })}</p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {(handleDelete.selectedRows() as U3121SubProject[]).map((row) => (
          <span key={row.id} className="inline-block text-gray-800">
            {row.subProjetNumber} - {row.subProjetName}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3121SubProjectDeleteDlg;
